import type { Response as ComparisonResponse } from '../lib/types/results';
import type { ModelResponse } from '../services/comparison';

export type AnyResponse = Pick<ComparisonResponse, 'content' | 'response'> & Partial<ModelResponse> & {
  rawResponse?: unknown;
};

function extractFromRaw(raw: unknown): string | null {
  if (!raw) return null;
  if (typeof raw === 'string') return raw;
  if (typeof raw === 'object') {
    const maybeContent = (raw as { content?: unknown }).content;
    if (typeof maybeContent === 'string') return maybeContent;
    const maybeText = (raw as { text?: unknown }).text;
    if (typeof maybeText === 'string') return maybeText;
  }
  return null;
}

export function getResponseContent(response: AnyResponse | null | undefined): string {
  if (!response) return '';

  const candidates: Array<string | null | undefined> = [
    typeof response.response === 'string' ? response.response : null,
    typeof response.content === 'string' ? response.content : null,
    extractFromRaw((response as { rawResponse?: unknown }).rawResponse),
  ];

  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim().length > 0) {
      return candidate;
    }
  }

  return '';
}
